import Select from './select';

export default Select;

export { SelectProps, OptionProps, OptGroupProps } from './interface';
